export const SECONDARY_BACKGROUND = '#f5fafc';
